import type {EditorState, Transaction} from "prosemirror-state";
import type {EditorView} from "prosemirror-view";

import type {AppState} from "@stores/AppState";
import type {ImageContextPropsSelfProps} from '../../../../ui/elements/context-menu/editor/ImageToolbar';

import {MODALS} from "../../../../ui/screens/modals/modal-names";



export const openPreview = (state: EditorState, dispatch?: (tr: Transaction) => void, view?: EditorView, params?: ImageContextPropsSelfProps): boolean => {
    const pos = params!.getPos();
    if (pos === undefined) {
        return false;
    }
    const imageNode = state.doc.nodeAt(pos);
    if (!imageNode) {
        return false;
    }

    const appState = state.schema.cached.app.appState as AppState;
    appState.setModal({name: MODALS.IMAGE_PREVIEW, params:{
        s3FileName: imageNode.attrs.s3FileName,
    }});
    return true;
}
